import { useEffect } from "react";

// Evergiving
import { FormConfig } from "@evergiving/common/dist/es2015/form";

// Hooks
import { useFormRouter } from "@/lib/hooks/useFormRouter";

function useDNSPrefetch(href: string | undefined) {
  useEffect(() => {
    if (href) {
      const linkTag = document.createElement("link");
      linkTag.rel = "dns-prefetch";
      linkTag.href = href;
      document.head.appendChild(linkTag);
      return () => {
        linkTag.remove();
      };
    }

    return () => {};
  }, [href]);
}

export function useSubmissionPrefetching(formConfig: FormConfig) {
  const formRouter = useFormRouter();

  useEffect(() => {
    formRouter.prefetchPage("thanks");
  }, [formRouter]);

  const { submissionEndpointUrl, address } = formConfig;

  useDNSPrefetch(submissionEndpointUrl);
  useDNSPrefetch(
    address && "melissa" in address
      ? address.melissa.addressCompletionEndpointUrl
      : undefined
  );
}
